(function () {
  const SIZE_PLACEHOLDER = '%%SIZE%%';

  function getSizeFromVariant(variant) {
    if (!variant) return '';
    return variant.option1 || variant.title || '';
  }

  function formatAddToCartLabel(template, size) {
    if (!template) return '';
    return template.split(SIZE_PLACEHOLDER).join(size);
  }

  function runAfterProductInfoSync(callback) {
    requestAnimationFrame(() => {
      requestAnimationFrame(callback);
    });
  }

  function initProductForm(productForm) {
    if (productForm.dataset.osheSizeGate !== 'true') return;

    const layout = productForm.closest('.oshe-product-layout');
    if (!layout) return;

    const variantSelects = layout.querySelector('variant-selects');
    const submitButton = productForm.querySelector('[type="submit"]');
    const submitButtonText = submitButton?.querySelector('span');
    if (!submitButton || !submitButtonText) return;

    const selectLabel = productForm.dataset.labelSelectASize || 'Select a size';
    const addToCartTemplate = productForm.dataset.labelAddToCartSize || 'Add to cart — %%SIZE%%';
    const sectionId = productForm.dataset.sectionId;

    function getCheckedSize() {
      const checked = variantSelects?.querySelector('fieldset input[type="radio"]:checked:not(:disabled)');
      return checked?.value || '';
    }

    function applySelectSizeState() {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.classList.add('oshe-cta--select-size');
      submitButtonText.textContent = selectLabel;
    }

    function applyReadyToCart(size) {
      submitButton.classList.remove('oshe-cta--select-size');
      submitButton.removeAttribute('disabled');
      submitButtonText.textContent = formatAddToCartLabel(addToCartTemplate, size);
    }

    function applySoldOutState() {
      submitButton.classList.remove('oshe-cta--select-size');
      submitButton.setAttribute('disabled', 'disabled');
      if (window.variantStrings?.soldOut) {
        submitButtonText.textContent = window.variantStrings.soldOut;
      }
    }

    function syncCtaFromSelection(variant) {
      const size = getSizeFromVariant(variant) || getCheckedSize();
      if (!size) {
        applySelectSizeState();
        return;
      }

      submitButton.classList.remove('oshe-cta--select-size');

      if (variant && variant.available === false) {
        applySoldOutState();
        return;
      }

      applyReadyToCart(size);
    }

    function scheduleSync(variant) {
      if (variant !== undefined) {
        runAfterProductInfoSync(() => syncCtaFromSelection(variant));
      } else {
        requestAnimationFrame(() => syncCtaFromSelection());
      }
    }

    syncCtaFromSelection();

    if (variantSelects) {
      variantSelects.addEventListener('change', () => scheduleSync(), { capture: true });
      variantSelects.addEventListener('click', (event) => {
        const input = event.target.closest('input[type="radio"]');
        if (!input || input.disabled) return;
        scheduleSync();
      });
    }

    layout.addEventListener('product-info:loaded', () => {
      scheduleSync();
    });

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
      if (!event.data?.event?.target || !layout.contains(event.data.event.target)) return;
      scheduleSync();
    });

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data?.sectionId !== sectionId) return;
      scheduleSync(event.data?.variant);
    });
  }

  function init() {
    document.querySelectorAll('.oshe-product-layout product-form[data-oshe-size-gate="true"]').forEach(initProductForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
